import React, { useState } from "react";
import { useNavigateToDeviSubscribe } from "../../hooks/useNavigateToDeviSubscribe";
import { DeviPriceList } from "../../models/deviModel";
import { TranslationObject } from "../../models/translationModal";
import { ProfilePayload } from "../../models/userModels";
import { getTranslation } from "../../untils/index";

interface TariffTableProps {
    priceList?: DeviPriceList | null;
    entities?: TranslationObject;
    profile?: ProfilePayload | null;
    /** Вызов при клике «Купить подписку» от заказчика (как в баннере) */
    onCustomerBuyClick?: () => void;
}

const TariffTable: React.FC<TariffTableProps> = ({
    priceList,
    entities,
    profile,
    onCustomerBuyClick,
}) => {
    const t = (entities: any, code: string) => getTranslation(entities, code);
    const handleButtonClick = useNavigateToDeviSubscribe({
        profile,
        onCustomerBuyClick,
    });
    const [selectedRow, setSelectedRow] = useState<{
        itemIndex: number;
        period: string;
    } | null>(null);

    if (!priceList?.items?.length) {
        return null;
    }

    const columnCount = priceList.items.length;

    return (
        <div className="tariff-table">
            <h1 className="tariff-table__heading">
                {t(entities, "devi_price_list_title")}
            </h1>
            <div
                className="tariff-table__container"
                style={{
                    gridTemplateColumns: `repeat(${columnCount}, minmax(0, 1fr))`,
                }}
            >
                {priceList.items.map((listItem, itemIndex) => (
                    <div
                        key={`head-${itemIndex}`}
                        className="tariff-table__head-cell"
                        style={{
                            gridColumn: itemIndex + 1,
                            gridRow: 1,
                            order: itemIndex * 2 + 1,
                        }}
                    >
                        <p className="tariff-table__title">
                            {itemIndex === 0
                                ? t(
                                      entities,
                                      "devi_price_list_title_verified"
                                  )
                                : t(
                                      entities,
                                      "devi_price_list_title_unverified"
                                  )}
                        </p>
                        {listItem.description && (
                            <p className="tariff-table__description">
                                {itemIndex === 0
                                    ? t(
                                          entities,
                                          "devi_price_list_description_verified"
                                      )
                                    : t(
                                          entities,
                                          "devi_price_list_description_unverified"
                                      )}
                            </p>
                        )}
                    </div>
                ))}
                {priceList.items.map((listItem, itemIndex) => (
                    <div
                        key={`table-${itemIndex}`}
                        className="tariff-table__table-cell new-offer-form__block"
                        style={{
                            gridColumn: itemIndex + 1,
                            gridRow: 2,
                            order: itemIndex * 2 + 2,
                        }}
                    >
                        <div className="table">
                            <table>
                                <tbody>
                                    {listItem.data?.map((row) => (
                                        <tr key={row.period}>
                                            <td>
                                                <div className="custom-toggle custom-toggle--radio">
                                                    <label>
                                                        <input
                                                            type="radio"
                                                            name={`postsRate-${itemIndex}`}
                                                            checked={
                                                                selectedRow?.itemIndex ===
                                                                    itemIndex &&
                                                                selectedRow?.period ===
                                                                    row.period
                                                            }
                                                            onChange={() =>
                                                                setSelectedRow({
                                                                    itemIndex,
                                                                    period: row.period,
                                                                })
                                                            }
                                                        />
                                                        <span className="custom-toggle__label">
                                                            {row.period_label}
                                                        </span>
                                                    </label>
                                                </div>
                                            </td>
                                            <td>{row.value}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                ))}
            </div>
            <div className="subscription-wrapper">
                <button
                    type="button"
                    className="subscription-button"
                    onClick={handleButtonClick}
                >
                    {t(entities, "devi_price_list_btn_text")}
                </button>
            </div>
        </div>
    );
};

export default TariffTable;
